import { Navigate } from "react-router-dom";

/** Legacy route: capacity settings live on Manufacturing management · Settings. */
export function ProductionCapacitySettingsPage() {
  return <Navigate to="/manufacturing-management/settings#production-capacity" replace />;
}
